if (!customElements.get('shop-the-look')) {
  customElements.define(
    'shop-the-look',

    class ShopTheLook extends HTMLElement {
      constructor() {
        super();
        this.containerID = this.getAttribute('data-id');
        this.container = document.getElementById(this.containerID);
        this.stl_items = this.container.querySelectorAll('.collection-itemlink');
        this.stlcloseO = this.container.querySelectorAll('.cc__stloverlay, .cc__stlclose');
      }

      connectedCallback() {
        this.stl_items.forEach(item => {
          item.addEventListener('click', this.openItem.bind(this));
        });

        this.stlcloseO.forEach(item => {
          item.addEventListener('click', this.closeItem.bind(this));
        });
      }

      openItem(e) {
        const targetUrl = e.currentTarget.getAttribute('data-target');
        document.getElementById(targetUrl)?.classList.add('stlopen');
      }

      closeItem(e) {
        const btn = e.currentTarget.closest('button');
        const targetClose = btn ? btn.dataset.close : null;

        if (targetClose) {
          document.getElementById(targetClose)?.classList.remove('stlopen');
          return;
        }

        e.currentTarget.closest('.stlopen')?.classList.remove('stlopen');
      }
    }
  );
}

if (!customElements.get('cc-quick-add')) {
  customElements.define(
    'cc-quick-add',

    class CCQuickAdd extends HTMLElement {
      constructor() {
        super();

        this.form             = this.querySelector('form');
        this.sectionID        = this.form.dataset.blockid;
        this.inputId          = this.form.querySelector('.qa-variant-id');
        
        this.form.addEventListener('submit', this.onSubmit.bind(this));

        this.submitButton     = this.form.querySelector('.cc_qa');
        this.selector         = this.querySelector('.cc_qa-selector');
        this.currentSel       = this.selector.querySelector('.cc_qa-current');
        this.options          = this.selector.querySelectorAll('.cc_qa-varitem');

        this.productPrice     = document.querySelector(`#stl-${this.sectionID} .cc__stlprice`);

        this.productJSON      = this.querySelector('[data-productJSON]');
      }

      connectedCallback() {
        this.options.forEach(item => {
          item.addEventListener('click', this.setCurrentVariant.bind(this));
        });

        this.selector.addEventListener('click', this.openOptions.bind(this));
      }

      setCurrentVariant(e) {
        // Prevent parent .cc_qa-selector click event from toggling again
        e.stopPropagation();

        const productId = e.currentTarget.getAttribute('data-id');
        this.inputId.value = productId;
        this.currentSel.textContent = e.currentTarget.innerText;

        // Close the dropdown
        this.selector.classList.remove('cc_qa-open');

        let currentJSON           = JSON.parse(this.productJSON.textContent);
        let currentData           = currentJSON.variants.find((item) => item.id == productId );
        let currentPrice          = currentData.price ? window.theme.formatMoney(currentData.price, theme.moneyFormat) : '';
        let currentPriceCompare   = currentData.compare_at_price ? window.theme.formatMoney(currentData.compare_at_price, theme.moneyFormat) : '';

        if( !currentPriceCompare ){
          this.productPrice.querySelector('.new-price').textContent = currentPrice;
        } else {
          this.productPrice.querySelector('.new-price').textContent = currentPrice;
          this.productPrice.querySelector('.old-price').textContent = currentPriceCompare;
        }
      }

      openOptions(e) {
        this.selector.classList.toggle('cc_qa-open');
      }

      onSubmit(e){
        e.preventDefault();

        document.dispatchEvent(
          new CustomEvent('theme:cart:add', {
            detail: {
              button: this.submitButton,
            },
            bubbles: false,
          })
        );

      }

      toggleSubmitButton(disable = true, text = window.theme.strings.addToCart) {
        this.submitButton.toggleAttribute('disabled', disable);
        this.submitButtonText.textContent = text;
      }
    }
  );
}

// CUSTOM TAB COLLECTIONS
document.querySelectorAll('.tab-link').forEach((item)=>{
  item.addEventListener('click', et=>{
      let sectionidd = et.currentTarget.dataset.section;
      let dataurl = et.currentTarget.dataset.url;

      if( sectionidd && dataurl ){
          document.getElementById(sectionidd).querySelector('.btnholder a').href = dataurl;
      }
  })
});
// END CUSTOM TAB COLLECTIONS




  let productId = document.querySelector('.product-variant-id');
  let productJSON = document.querySelector('[data-productjson]');
  let productFormWrapper = document.querySelector('[data-form-wrapper]');
  let productStockCount = document.querySelector('[data-productstock-remaining-json]');
  let ccStock = document.querySelector('.cc__stockcounts');



  if( productId || productJSON || productStockCount){
    productId.addEventListener('change', et=>{
      let pJSON = JSON.parse(productJSON.innerHTML);
      let currentID = et.currentTarget.value;

      const productInfo = pJSON.filter(i=>{
        return i.id == currentID;
      });
      
      if( !productInfo[0].available){
        productFormWrapper.classList.add('variant--soldout');
      } else {
        productFormWrapper.classList.remove('variant--soldout');
      }

      if( productStockCount){
        let stockJSON = JSON.parse(productStockCount.innerHTML);
        const remaining = stockJSON[currentID];

        if( remaining == 'unavailable'){
          ccStock.classList.remove('cc__lowinstock');
        } else {
          if( (remaining < ccStock.dataset.threshold)){
            ccStock.classList.add('cc__lowinstock');
          } else{
            ccStock.classList.remove('cc__lowinstock');
          }
        }
      }
    });
  }